var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeMans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 49,
    viewBox: "0 0 130 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39685 34.7201L4.5 35.5L7.37348 34.638L3.45183 21.5658C3.15221 20.5671 3 19.53 3 18.4873C3 12.958 7.2078 8.33702 12.7129 7.82059L64.1004 3H92.7373C94.7335 3 96.7259 3.17445 98.6917 3.52136L124.079 8.00149C125.768 8.29961 127 9.7675 127 11.483C127 12.6708 126.403 13.7792 125.412 14.4335L107.431 26.301C103.868 28.6525 102.434 33.1742 103.989 37.1495C104.695 38.9528 103.562 40.9483 101.652 41.2666L80.1311 44.8534C78.5548 45.1161 76.9523 44.567 75.8684 43.3928C73.1678 40.4672 69.0704 39.2755 65.222 40.2965L49.5889 44.444C46.9467 45.145 44.2246 45.5 41.491 45.5H21.4629C14.8763 45.5 9.10919 41.0802 7.39685 34.7201Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeMans);
export default __webpack_public_path__ + "static/media/le_mans.27e76806.svg";
export { ForwardRef as ReactComponent };